var map = {
	"./Bar.svg": "d061",
	"./Blobbig.svg": "4c68",
	"./Blobsmall.svg": "9c03",
	"./Blue-shape.svg": "c3ef",
	"./Cafe.svg": "0363",
	"./CollapseButtomIcon.svg": "0af0",
	"./Connection-Lost.svg": "92e1",
	"./ExpandButtonIcon.svg": "ab51",
	"./JumpoffBgc.svg": "f191",
	"./NoSearchResults-Columbo.svg": "3046",
	"./Restaurant.svg": "c136",
	"./RightLoginFrame.svg": "0d5d",
	"./RightLoginFrameSmall.svg": "6ace",
	"./activityicon/activityCheck.svg": "1138",
	"./activityicon/activityData.svg": "4fb3",
	"./activityicon/activityDataLoading.svg": "e18b",
	"./activityicon/newDot.svg": "f9b7",
	"./add-circle-outline-white.svg": "ae38",
	"./add-circle-outline.svg": "85fb",
	"./arrowDown.svg": "2b3b",
	"./arrowDownHover.svg": "7067",
	"./arrowLeft-grey.svg": "a185",
	"./arrowLeft.svg": "ce7f",
	"./arrowUp.svg": "d9fc",
	"./arrowUpHover.svg": "7a2a",
	"./arrow_diagonal_up_right_blue.svg": "ae96",
	"./arrow_right.svg": "d03c",
	"./arrow_right_white.svg": "fd1d",
	"./basic-icon.svg": "2600",
	"./basic-loading-icon.svg": "bef5",
	"./beer.svg": "61dd",
	"./bel-icon.svg": "cd6f",
	"./blob1.svg": "ef71",
	"./blob2.svg": "3e87",
	"./blob3.svg": "01a3",
	"./cart.svg": "6f5d",
	"./categoryicon/A.svg": "1633",
	"./categoryicon/C.svg": "8921",
	"./categoryicon/D.svg": "92a9",
	"./categoryicon/F.svg": "c480",
	"./categoryiconwithoutside/C.svg": "fe75",
	"./categoryiconwithoutside/D.svg": "0bd2",
	"./categoryiconwithoutside/F.svg": "3297",
	"./close-outline.svg": "b412",
	"./dashmote-logo-white.svg": "9cde",
	"./dashmote-logo.svg": "ae46",
	"./deepbluemarker.svg": "54d3",
	"./filter.svg": "5ee4",
	"./greenmarker.svg": "a989",
	"./grid-outline-circle.svg": "617e",
	"./grid-outline.svg": "db5d",
	"./icon_data_source_changed.svg": "db42",
	"./icon_grid_filled.svg": "9705",
	"./icon_user.svg": "97fc",
	"./intersect.svg": "aece",
	"./jumpBottom.svg": "c0c2",
	"./jumpMiddle.svg": "81c8",
	"./loadingBar.svg": "f1a6",
	"./loadingBarMiddle.svg": "ad8e",
	"./loadingBarSmall.svg": "bcca",
	"./location-blue.svg": "d7fe",
	"./location-outline.svg": "be45",
	"./markerIcon.svg": "8ee3",
	"./mealdelivery.svg": "8d4f",
	"./menu-icon-white.svg": "d6ae",
	"./menu-icon.svg": "9605",
	"./menuicons/log-out-icon.svg": "0f42",
	"./menuicons/notifications-icon.svg": "f0ce",
	"./menuicons/projects-icon.svg": "08e8",
	"./menuicons/training-icon.svg": "c0aa",
	"./menuicons/university-icon.svg": "3bf7",
	"./menuicons/user-icon.svg": "8604",
	"./noDashboardsImage.svg": "4f9b",
	"./noProjectsImage.svg": "45ac",
	"./noResult.svg": "f8f2",
	"./notifications-outline.svg": "3803",
	"./nounBeer.svg": "3594",
	"./nounCloche.svg": "b14b",
	"./nounKiosk.svg": "54cd",
	"./nounMenu.svg": "b1a7",
	"./nounTea.svg": "0520",
	"./open-outline.svg": "7ca3",
	"./other.svg": "428e",
	"./pencil.svg": "33bf",
	"./phone.svg": "001e",
	"./pie-chart-blue.svg": "3faf",
	"./pie-chart-outline.svg": "7225",
	"./pizza.svg": "a6a2",
	"./profilePhotoPlaceholder.svg": "6aac",
	"./profileimageoverlay.svg": "7df4",
	"./project_outline.svg": "7bfa",
	"./ratingstart.svg": "f3a5",
	"./reader-blue.svg": "59e5",
	"./reader-outline.svg": "d700",
	"./redmarker.svg": "dd9a",
	"./reviewsInfo.svg": "b639c",
	"./selectBgc.svg": "75f4",
	"./setupstepicon/ActionIcon.svg": "5cae",
	"./setupstepicon/DoneIcon.svg": "3224",
	"./setupstepicon/IconSubmitted.svg": "1e2a",
	"./setupstepicon/OpenIcon.svg": "1521",
	"./setupstepicon/check.svg": "2c57",
	"./setupstepicon/closeIcon.svg": "d418",
	"./setupstepicon/closeModalCross.svg": "88b8",
	"./setupstepicon/dashboardoverviewVisual.svg": "5438",
	"./setupstepicon/dataroomVisual.svg": "d43c",
	"./setupstepicon/download_icon_active.svg": "76cd",
	"./setupstepicon/download_icon_disabled.svg": "7bcd",
	"./setupstepicon/excel.svg": "66ae",
	"./setupstepicon/expand-outline.svg": "f9a6",
	"./setupstepicon/headerImage.svg": "3efb",
	"./setupstepicon/information.svg": "bdc9",
	"./setupstepicon/openManagement.svg": "43f1",
	"./setupstepicon/pdf.svg": "a2e3",
	"./setupstepicon/setupstepsVisual.svg": "b0b7",
	"./setupstepicon/unknown.svg": "ebe9",
	"./setupstepicon/upload-icon.svg": "efbe",
	"./setupstepicon/uploadButton.svg": "a463",
	"./setupstepicon/uploadButtonHover.svg": "f91b",
	"./setupstepicon/uploadcardBackground.svg": "9c03c",
	"./singleoutleticon/arrow_diagonal_up_right_purple.svg": "7a7b",
	"./singleoutleticon/arrow_share.svg": "5057",
	"./singleoutleticon/icon_accepted.svg": "8fea",
	"./singleoutleticon/icon_address.svg": "754d",
	"./singleoutleticon/icon_cafe.svg": "a253",
	"./singleoutleticon/icon_check.svg": "aa71",
	"./singleoutleticon/icon_copy.svg": "ccb7",
	"./singleoutleticon/icon_cross.svg": "116c",
	"./singleoutleticon/icon_facebook.svg": "3e0d",
	"./singleoutleticon/icon_id.svg": "49b0",
	"./singleoutleticon/icon_instagram.svg": "2361c",
	"./singleoutleticon/icon_mappin.svg": "7c56",
	"./singleoutleticon/icon_noimages.svg": "aa9a",
	"./singleoutleticon/icon_openingtimes.svg": "abaf",
	"./singleoutleticon/icon_telephone.svg": "8329",
	"./singleoutleticon/icon_tripadvisor.svg": "b481",
	"./singleoutleticon/share_googlemaps_icon.svg": "7226",
	"./singleoutleticon/share_upload_icon.svg": "e598",
	"./singleoutleticon/share_url_icon.svg": "fe5a",
	"./topLoginFrameSmall.svg": "251c",
	"./trash-outline.svg": "988e",
	"./yellomarker.svg": "d50b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";